import Icon from '../components/Icon.vue'

Icon.register({
  'car-side': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M544 192c53 0 96 43 96 96v80c0 8.8-7.2 16-16 16h-48c0 53-43 96-96 96s-96-43-96-96h-128c0 53-43 96-96 96s-96-43-96-96h-48c-8.8 0-16-7.2-16-16v-112c0-29.8 20.4-54.6 48-61.7l47.9-122c9.7-24.3 33.3-40.2 59.4-40.2h213.9c17 0 39.4 10.8 50 24l108.8 136h16zM160 432c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zM232 192v-96h-76.7l-38.4 96h115.1zM280 192h166l-76.8-96h-89.2v96zM480 432c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48z'
      }
    ]
  }
})
